import trpc from "../utils/trpc.js";

/**
 * Fetch Canvas brand variables (cached indefinitely) and derive an inline CSS
 * string usable inside <IsolatedHtml>. Returns both raw vars and CSS.
 */
export function useCanvasBrandVariables() {
  const query = trpc.course.getBrandVariables.useQuery(undefined, { staleTime: Infinity });

  // Local helper (inlined) to build :host CSS custom property declarations.
  const inlineCss = (() => {
    const vars = query.data;
    if (!vars) return "";
    const decls: string[] = [];
    for (const [key, value] of Object.entries(vars)) {
      if (!value) continue;
      const trimmed = value.trim();
      if (!trimmed) continue;
      const finalValue = trimmed.startsWith("#") ? trimmed.toLowerCase() : trimmed;
      decls.push(`  --${key}: ${finalValue};`);
    }
    if (!decls.length) return "";
    return `:host {\n${decls.join("\n")}\n}`;
  })();

  return { ...query, variables: query.data, inlineCss };
}
